module.exports = __webpack_public_path__ + "img/07c55f2.jpg";